import { buildOpenObjectBuilderActionHook } from './buildOpenObjectBuilderAction';
export const useOpenRecordCreatorFormAction = buildOpenObjectBuilderActionHook();